import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import debounce from 'lodash.debounce';

const AmountInputWithTooltip = ({
  currency,
  register,
  watch,
  anyArrayHasValue,
  isFixed,
  showTooltipError,
  setShowTooltipError,
  handleTotalAmountChange,
  amountFieldRegister,
}) => {
  const shouldShowTooltip = Object.values({
    ...showTooltipError,
    LessAmountEUR: showTooltipError.LessAmountEUR,
    LessAmountUSD: showTooltipError.LessAmountUSD,
    LessAmountGBP: showTooltipError.LessAmountGBP,
    LessAmountCHF: showTooltipError.LessAmountCHF,
    LessAmountCAD: showTooltipError.LessAmountCAD,
    LessAmountAUS: showTooltipError.LessAmountAUS,
    LessAmountNOK: showTooltipError.LessAmountNOK,
    LessAmountDKK: showTooltipError.LessAmountDKK,
    LessAmountJPY: showTooltipError.LessAmountJPY,
    LessAmountCNY: showTooltipError.LessAmountCNY,
  }).some(Boolean);

  const popoverContent = (
    <Popover id="popover-amount-error" style={{ margin: 0 }}>
      <Popover.Header className="text-danger" as="h3">
        {showTooltipError.notOfFixedPrice && 'Please Select Fixed Price'}
        {showTooltipError.negativeAmount && "Amount value can't be Negative"}
        {showTooltipError.NullAmount && 'Please enter amount'}
        {showTooltipError.LessAmount && 'The minimum allowable amount is 100.'}
        {showTooltipError.LessAmountEUR && 'The minimum allowable amount is 10.'}
        {showTooltipError.LessAmountUSD && 'The minimum allowable amount is 11.'}
        {showTooltipError.LessAmountGBP && 'The minimum allowable amount is 9.'}
        {showTooltipError.LessAmountCHF && 'The minimum allowable amount is 10.'}
        {showTooltipError.LessAmountCAD && 'The minimum allowable amount is 15.'}
        {showTooltipError.LessAmountAUS && 'The minimum allowable amount is 17.'}
        {showTooltipError.LessAmountNOK && 'The minimum allowable amount is 118.'}
        {showTooltipError.LessAmountDKK && 'The minimum allowable amount is 75.'}
        {showTooltipError.LessAmountJPY && 'The minimum allowable amount is 1576.'}
        {showTooltipError.LessAmountCNY && 'The minimum allowable amount is 77.'}
      </Popover.Header>
    </Popover>
  );

  return (
    <OverlayTrigger
      show={shouldShowTooltip}
      placement="left"
      overlay={popoverContent}
    >
      <input
        className="border-0 btn-primary w-75 m-0 p-0 bg-light text-dark"
        placeholder={currency}
        min="0"
        readOnly={(!watch('invoiceHours') && !anyArrayHasValue) || !isFixed}
        {...register('totalAmount')}
        onClick={() => {
          if (!isFixed) {
            setShowTooltipError({ notOfFixedPrice: true });
            setTimeout(() => {
              setShowTooltipError({ notOfFixedPrice: false });
            }, 3000);
          }
        }}
        onKeyDown={(e) => {
          if (
            !/[\d.]/.test(e.key) &&
            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(e.key)
          ) {
            e.preventDefault();
          }
        }}
        onKeyUp={handleTotalAmountChange}
        {...amountFieldRegister}
        onChange={debounce(async (e) => {
          await amountFieldRegister.onChange(e);
        }, 600)}
      />
    </OverlayTrigger>
  );
};

export default AmountInputWithTooltip;
